import { app } from "../firebase";
import { getFunctions } from "firebase/functions";

const functions = getFunctions(app);

/**
 * Envía una notificación por correo o SMS usando las funciones HTTPS de Firebase.
 * @param {'email' | 'sms'} type - Canal de envío.
 * @param {object} payload - Datos del mensaje (to, subject, html, message, etc).
 */
export async function sendNotification(type, payload) {
  if (!["email", "sms"].includes(type)) {
    throw new Error(`Canal "${type}" no es válido. Usa 'email' o 'sms'.`);
  }

  try {
    if (type === "email") {
      // --- EMAIL ---
      const emailPayload = {
        to: payload.to,
        subject: payload.subject,
        html: payload.html,
        text:
          payload.text ||
          payload.message ||
          payload.html.replace(/<[^>]+>/g, "").trim(),
      };

      const response = await fetch(
        "https://us-central1-tarjeta-ad945.cloudfunctions.net/sendClientEmail",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(emailPayload),
        }
      );

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error?.error || "Error desconocido en envío de correo");
      }

      const data = await response.json();
      console.log("✅ EMAIL enviado con éxito", data);
      return data;
    } else {
      // --- SMS ---
      const footer = "\n\n(No respondas a este número; es un canal de notificaciones de BBTS.)";
      const smsPayload = {
        to: payload.to,
        message: `${payload.message?.trim() || ''}${footer}`.trim(),
      };

      const response = await fetch(
        "https://us-central1-tarjeta-ad945.cloudfunctions.net/sendSmsNotification",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(smsPayload),
        }
      );

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error?.error || "Error desconocido en envío de SMS");
      }

      const data = await response.json();
      console.log("✅ SMS enviado con éxito", data);
      return data;
    }
  } catch (error) {
    console.error(`❌ Error enviando ${type.toUpperCase()}:`, error);
    throw error;
  }
}
